import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, DateDecoder, EnumDecoder, field, IntegerDecoder, StringDecoder } from "@simonbackx/simple-encoding";
import { v4 as uuidv4 } from "uuid";
import { Business } from "./Customer";
import { File } from "./files/File";
import { PrivateOrder } from "./Order";
import { OrderPrices } from "./OrderPrices";
import { PaymentMethod } from "./PaymentMethod";
export var InvoiceType;
(function (InvoiceType) {
    InvoiceType["Invoice"] = "Invoice";
    InvoiceType["CreditNote"] = "CreditNote";
})(InvoiceType || (InvoiceType = {}));
export class InvoiceItem extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.name = "";
        this.description = "";
        this.amount = 1;
        this.unitPrice = 1;
    }
    get price() {
        return this.amount * this.unitPrice;
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], InvoiceItem.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], InvoiceItem.prototype, "name", void 0);
__decorate([
    field({ decoder: StringDecoder })
], InvoiceItem.prototype, "description", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], InvoiceItem.prototype, "amount", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], InvoiceItem.prototype, "unitPrice", void 0);
/**
 * Make some properties required when saved in an order
 */
export class InvoiceData extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.prices = OrderPrices.create({});
        this.items = [];
    }
    get VATPercentage() {
        return 21;
    }
}
__decorate([
    field({ decoder: File, optional: true })
], InvoiceData.prototype, "pdf", void 0);
__decorate([
    field({ decoder: Business })
], InvoiceData.prototype, "business", void 0);
__decorate([
    field({ decoder: new EnumDecoder(PaymentMethod) })
], InvoiceData.prototype, "paymentMethod", void 0);
__decorate([
    field({ decoder: OrderPrices })
], InvoiceData.prototype, "prices", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(InvoiceItem) })
], InvoiceData.prototype, "items", void 0);
export class Invoice extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.paidAt = null;
    }
}
__decorate([
    field({ decoder: StringDecoder })
], Invoice.prototype, "id", void 0);
__decorate([
    field({ decoder: InvoiceData })
], Invoice.prototype, "data", void 0);
__decorate([
    field({ decoder: new EnumDecoder(InvoiceType) })
], Invoice.prototype, "type", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true })
], Invoice.prototype, "paidAt", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], Invoice.prototype, "number", void 0);
__decorate([
    field({ decoder: DateDecoder })
], Invoice.prototype, "createdAt", void 0);
__decorate([
    field({ decoder: DateDecoder })
], Invoice.prototype, "updatedAt", void 0);
export class PrivateInvoice extends Invoice {
    constructor() {
        super(...arguments);
        this.order = null;
    }
}
__decorate([
    field({ decoder: PrivateOrder, nullable: true })
], PrivateInvoice.prototype, "order", void 0);
//# sourceMappingURL=Invoice.js.map